/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Driver_Held1Inputs */

const vi_driverremittance_driver_held1 = /** @type {(inputs: Driverremittance_Driver_Held1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài xế đang giữ`)
};

/**

* @param {Driverremittance_Driver_Held1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_driver_held1 = /** @type {((inputs?: Driverremittance_Driver_Held1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Driver_Held1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_driver_held1(inputs)
});
export { driverremittance_driver_held1 as "driverRemittance_driver_held" }